<div class="terms-of-service-dialog">
  <mat-dialog-content class="!p-0">
    <header class="modal-header flex justify-between !h-auto p-0">
      <h2 class="modal-headline" *ngIf="this.env.brandingKey !== CustomClients.VKB" i18n>Terms of use and privacy policy</h2>
      <!-- Close dialog button -->
      <button mat-icon-button type="button" (click)="onCancelClick()" class="button-close ml-auto">
        <mat-icon class="material-icons-outlined" aria-hidden="true">close</mat-icon>
        <span class="sr-only" i18n>Close</span>
      </button>
    </header>
    <div *ngIf="env.termsConditionsPopup?.logoSrc" class="flex terms-logo-container justify-center items-center mb-4 h-auto">
      <img class="terms-logo" [src]="env.termsConditionsPopup?.logoSrc" />
    </div>
    <div class="flex content-container flex-row box-border place-content-center items-center h-auto">
      <div class="content-inner flex-1 box-border w-full">
        <div *ngIf="content" class="content-wrapper">
          <div class="content mt-2" [innerHTML]="content"></div>
          <div class="actions flex flex-row justify-end w-full mt-4 p-2">
            <button type="button" class="button-primary" mat-flat-button (click)="onAcceptClick()" i18n>I accept</button>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>
